import MomentUtils from "@date-io/moment";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import locale from "moment/locale/pt-br";
import React, { PureComponent } from "react";
import { SelectCombo } from "../../../componentes/Select";
import { ListarItensConciliadoresDocument } from "../../../graphql/components";
import { variablesDashBoard, variablesDashBoardExibicao } from "./utilsDashBoard";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import FilterContext from "../../../componentes/CRUD/filterContext";

interface Props {
  variables: typeof variablesDashBoard;
  variablesValorExibicao: typeof variablesDashBoardExibicao;
  isFiltering: boolean;
}
type State = typeof variablesDashBoard;

class FilterDashBoard extends PureComponent<Props, State> {
  static contextType = FilterContext;
  constructor(props: Props) {
    super(props);
    // o drawer desmonta o filtro ao fechar, entao ao reabrir o estado precisa vir do filtro aplicado
    this.state = { ...props.variables };
  }

  render() {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <SelectCombo
            disabled={this.props.isFiltering}
            label="Conciliador"
            name="empresa"
            nameQuery="listarItensConciliadores"
            query={ListarItensConciliadoresDocument}
            value={this.state.empresa ? this.state.empresa : ""}
            handleChange={(e) => {
              const value = e.target.value ? (e.target.value as string) : null;
              const label = value ? (e.currentTarget as any).innerText : null;
              this.setState({ empresa: value }, () => {
                this.props.variables.empresa = this.state.empresa;
                this.props.variablesValorExibicao.empresa = label;
              });
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <FormControl component="div">
            <FormLabel>Registros de:</FormLabel>
            <RadioGroup
              row
              aria-label="registro"
              name="registro"
              value={this.state.registro}
              onChange={(e: any) => {
                this.setState({ registro: e.target.value }, () => {
                  this.props.variables.registro = this.state.registro;
                  this.props.variablesValorExibicao.registro = this.state.registro === "PAGAMENTO" ? "Pagamento" : "Venda";
                });
              }}
            >
              <FormControlLabel value="PAGAMENTO" control={<Radio />} disabled={this.props.isFiltering} label="Pagamento" />
              <FormControlLabel value="VENDA" control={<Radio />} disabled={this.props.isFiltering} label="Venda" />
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MuiPickersUtilsProvider utils={MomentUtils} locale={locale}>
            <KeyboardDatePicker
              disabled={this.props.isFiltering}
              autoOk
              style={{ width: "100%" }}
              label="De"
              name="de"
              id="de"
              invalidDateMessage="Data inválida"
              disableToolbar
              variant="inline"
              value={this.state.de}
              minDateMessage={`O período máximo para a pesquisa deve ser de 1 mês`}
              maxDateMessage="O período máximo para a pesquisa deve ser de 1 mês"
              onChange={(e) => {
                if (e && e.toDate()) {
                  this.setState({ de: e.toDate() }, () => {
                    this.props.variables.de = this.state.de;
                    this.props.variablesValorExibicao.de = this.state.de;
                  });
                } else {
                  this.setState({ de: null }, () => {
                    this.props.variables.de = this.state.de;
                    this.props.variablesValorExibicao.de = this.state.de;
                  });
                }
              }}
              format="DD/MM/YYYY"
              placeholder="dd/mm/aaaa"
            />
          </MuiPickersUtilsProvider>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MuiPickersUtilsProvider utils={MomentUtils} locale={locale}>
            <KeyboardDatePicker
              disabled={this.props.isFiltering}
              autoOk
              style={{ width: "100%" }}
              label="Até"
              name="ate"
              id="ate"
              invalidDateMessage="Data inválida"
              disableToolbar
              variant="inline"
              minDateMessage={`O período máximo para a pesquisa deve ser de 1 mês`}
              maxDateMessage="O período máximo para a pesquisa deve ser de 1 mês"
              value={this.state.ate}
              onChange={(e) => {
                if (e && e.toDate()) {
                  this.setState({ ate: e.toDate() }, () => {
                    this.props.variables.ate = this.state.ate;
                    this.props.variablesValorExibicao.ate = this.state.ate;
                  });
                } else {
                  this.setState({ ate: null }, () => {
                    this.props.variables.ate = this.state.ate;
                    this.props.variablesValorExibicao.ate = this.state.ate;
                  });
                }
              }}
              format="DD/MM/YYYY"
              placeholder="dd/mm/aaaa"
            />
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>
    );
  }
}

export default FilterDashBoard;
